import axios from 'axios';

const buildApi = () => {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  const base = raw.replace(/\/api$/, '');
  return `${base}/api`;
};

export async function fetchWorkflowTestContacts({ token, agencyId, scope = 'agency' }) {
  const api = buildApi();
  const headers = { Authorization: `Bearer ${token}` };

  if (scope === 'platform') {
    const response = await axios.get(`${api}/platform/contacts`, {
      headers,
      params: { limit: 50, page: 1 },
    });
    const rows = response.data?.contacts || response.data?.items || response.data?.data || [];
    return rows.map((contact) => ({
      id: contact.id || contact.contact_id || contact._id,
      label: contact.full_name
        || `${contact.first_name || ''} ${contact.last_name || ''}`.trim()
        || contact.email
        || contact.id,
      email: contact.email,
    })).filter((contact) => contact.id);
  }

  if (!agencyId) return [];
  const response = await axios.get(`${api}/agencies/${agencyId}/contacts`, {
    headers,
    params: { limit: 50, page: 1 },
  });
  const rows = response.data?.contacts || response.data?.items || response.data?.data || [];
  return rows.map((contact) => ({
    id: contact.id || contact.contact_id || contact._id,
    label: contact.full_name
      || `${contact.first_name || ''} ${contact.last_name || ''}`.trim()
      || contact.email
      || contact.id,
    email: contact.email,
  })).filter((contact) => contact.id);
}

export async function runWorkflowTest({
  token,
  workflowId,
  contactId,
  agencyId,
}) {
  const api = buildApi();
  const response = await axios.post(
    `${api}/workflow-actions/start`,
    {
      workflow_id: workflowId,
      contact_id: contactId,
      agency_id: agencyId || undefined,
      triggered_by: 'manual_test',
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
}
